import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { InboundLoadsExtended } from 'common/api-types/gateway';
import { WoltInboundLoads } from 'common/api-types/warehouse';
import { isToday } from 'features/warehouse/receiving/utils';

import { expandedInboundLoadsAtom } from './useExpandedInboundLoads';

const getInboundLoadIds = (inboundLoads: WoltInboundLoads | InboundLoadsExtended): string[] => {
  const filterByArrivingToday = inboundLoads.filter((load) =>
    isToday(load.expectedDeliveryStartDate),
  );

  if (filterByArrivingToday.length > 0) {
    return filterByArrivingToday.map((load) => load.id);
  }

  return inboundLoads.map((load) => load.id);
};

export const useExpandInboundLoads = (
  inboundLoads: WoltInboundLoads | InboundLoadsExtended,
  itemSearchResult: boolean,
) => {
  const setExpandedInboundLoads = useSetAtom(expandedInboundLoadsAtom);
  useEffect(() => {
    if (itemSearchResult) {
      // When searching for an item, expand all inbound loads that are arriving today or in case there are no shipment arriving today, expand all inbound loads that matches the search
      const expandedInboundLoadIds = getInboundLoadIds(inboundLoads);
      setExpandedInboundLoads((loads) => [...new Set([...loads, ...expandedInboundLoadIds])]);
    }
  }, [inboundLoads, itemSearchResult, setExpandedInboundLoads]);
};
